import React from 'react';
import classNames from 'classnames';

import css from './IconDollarBag.module.css';

/**
 * Dollar bag icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconDollarBag = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Dollar bag"
    >
      <path
        d="M458.719,449.828c-2.203-6.172-5.375-11.234-8.688-15.891c-4.969-6.891-10.422-12.875-14.188-17.516
        c-1.766-2.125-3.078-3.906-3.719-4.938c-0.094-1.531-0.219-3.109-0.391-5.094c-1-10.359-3.391-29.094-5.969-50.656
        c-2.563-21.547-5.328-45.766-6.953-66.234c-3.516-43.969-26.891-85.953-66.172-111.797c-1.25-1.469-2.406-2.859-3.531-4.203h17.719
        l74.938-62.266c6.766-5.625,7.688-15.688,2.063-22.469c-5.641-6.781-15.703-7.719-22.469-2.063l-66.063,54.875h-10.344
        c3.672-6.688,8.422-15.547,13.219-25.172c5.016-10.078,10.063-20.922,14-31.094c1.984-5.094,3.688-10.031,4.969-14.797
        c1.25-4.797,2.188-9.328,2.219-14.406c-0.016-2.641-0.25-5.516-1.328-8.813l-1.219-3.656l-2.75-2.688
        c-10.313-10.047-23.219-15.594-36.297-18.938c-13.141-3.297-26.703-4.391-39.422-4.391c-11.594,0-22.344,0.922-31.328,2.172
        l-7.797-18.641l-9.734-0.719C245.547,0.141,241.703,0,237.984,0c-34.859-0.031-61.328,12.172-78.609,24.391
        c-17.344,12.219-25.891,24.344-26.641,25.391l-5.063,7.266l36.156,84.609c-8.516,0.344-15.297,7.297-15.297,15.891
        c0,8.563,6.766,15.5,15.25,15.875c-1.078,1.203-2.25,2.453-3.688,3.781C120.391,203,96.719,245.25,93.188,289.5
        c-1.875,23.406-5.203,51.688-8.047,75.281c-1.422,11.797-2.75,22.438-3.703,30.813c-0.484,4.188-0.875,7.813-1.156,10.797
        c-0.188,1.984-0.313,3.563-0.391,5.109c-0.828,1.313-2.797,3.875-5.281,6.828c-4.031,4.797-9.297,10.703-13.969,17.516
        c-2.344,3.422-4.547,7.125-6.328,11.328c-1.766,4.188-3.125,9.016-3.141,14.516c-0.109,13.328,6.25,26.938,17.953,36.109
        C80.813,507.047,96.953,512,116.734,512c34.328,0,137.344,0,137.344,0h3.828c0.016,0,6.438,0,16.641,0c30.594,0,94.984,0,120.719,0
        c19.766,0,35.922-4.953,47.609-14.203c11.688-9.156,18.063-22.781,17.953-36.109C460.828,457.313,459.953,453.359,458.719,449.828z
         M179,49.609c13.156-8.906,32.234-17.547,58.5-17.688l18.516,44.266c3.391,8.125,12.734,11.969,20.859,8.563
        c8.141-3.406,11.969-12.734,8.578-20.875l-1.844-4.391c-0.125-1.672-0.438-3.359-1.109-5l-1.734-4.141
        c5.5-0.484,11.469-0.813,17.578-0.813c10.813-0.016,22.047,1,31.594,3.438c6.781,1.688,12.5,4.141,16.938,7.016
        c-0.141,0.688-0.328,1.453-0.563,2.266c-1.484,5.609-4.5,13.531-8.188,21.828c-5.5,12.484-12.453,26.016-17.969,36.281
        c-2.766,5.156-5.188,9.5-6.906,12.547c-0.859,1.516-1.531,2.719-1.984,3.531c-0.469,0.813-0.703,1.203-0.703,1.203l0.016,0.016
        c-0.813,1.25-1.578,2.563-2.266,3.922H198.672c-0.75-1.844-1.563-3.625-2.438-5.297l-31.844-74.5
        C167.766,58.344,172.625,53.953,179,49.609z M423.031,472.797c-4.531,3.641-13.188,7.281-27.766,7.281c-17.172,0-51.5,0-81.563,0
        c-15.016,0-28.969,0-39.156,0c-10.203,0-16.625,0-16.641,0h-3.828c0,0-103.016,0-137.344,0c-14.578,0-23.234-3.641-27.766-7.281
        c-4.516-3.719-5.797-7.266-5.891-11.109l0.031-0.266c0.109-0.828,1.188-3.594,3.406-6.844c3.234-4.969,8.484-10.906,13.359-16.75
        c2.469-2.969,4.844-5.891,7-9.297c1.078-1.703,2.125-3.563,3.063-5.828c0.891-2.266,1.734-5.047,1.75-8.719
        c-0.016,0,0.094-1.984,0.344-4.547c0.891-9.313,3.313-28.297,5.891-49.922c2.594-21.688,5.359-46.203,7.063-67.469
        c2.828-35.125,21.828-68.813,53.688-88.891l1.156-0.734l1-0.891c7.156-6.438,12.531-13.172,16.141-20.297
        c1.313-2.547,2.281-5.141,3.094-7.734h110.109c1.781,3.359,3.766,6.609,6.156,9.906c3.719,5.125,8.156,10.5,13.391,16.625
        l1.563,1.844l2.047,1.281c31.844,20.078,50.844,53.766,53.672,88.891c1.953,24.297,5.297,52.859,8.172,76.563
        c1.438,11.844,2.75,22.469,3.688,30.641c0.484,4.078,0.859,7.547,1.109,10.188c0.266,2.563,0.359,4.547,0.344,4.547
        c0.094,5.219,1.625,8.594,3,11.391c2.531,4.797,5.438,8.328,8.484,12.063c4.531,5.469,9.438,10.969,12.797,15.797
        c1.656,2.391,2.922,4.563,3.594,6.141c0.344,0.781,0.547,1.391,0.641,1.797l0.094,0.422v0.094
        C428.828,465.531,427.547,469.078,423.031,472.797z"
        fill="currentColor"
      />
      <path
        d="M443.813,173.359l-35.266-18.984l-26.453,21.984l46.594,25.094c7.766,4.172,17.438,1.281,21.625-6.484
        C454.484,187.219,451.578,177.531,443.813,173.359z"
        fill="currentColor"
      />
      <path
        d="M302.719,301.844l-4.172-1.75c-6.875-2.922-14.016-4.359-21.234-4.359c-20.875,0-40.047,12.094-49.25,30.641
        h69.625l-4.281,20.797h-71c-0.078,1.172-0.141,2.375-0.141,3.578c0,2.969,0.266,6,0.781,9.047h67.766l-4.266,20.781h-55.422
        c10.125,15.719,27.313,25.25,46.188,25.25c6.406,0,12.828-1.188,19.078-3.516l4.984-1.859v29.266l-2.719,0.719
        c-7.016,1.891-14.188,2.844-21.344,2.844c-33.984,0-64.563-21.063-76.844-52.703h-17.594v-20.781h12.469
        c-0.375-3.203-0.563-6.156-0.563-9.047c0-1.172,0.031-2.406,0.078-3.578h-11.984v-20.797h15.703
        c10.641-34.375,42.641-58.156,78.734-58.156c9.594,0,19.016,1.703,28.031,4.984l3,1.109L302.719,301.844z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconDollarBag;

